import ReactDOM from 'react-dom';
import {
    getBottomSheetAnimatedDiv,
    purgeBottomSheetAnimatedDiv,
} from './bottomSheetAnimatedDivUtils';
/**
 * Unmount the bottomsheet component and remove the corresponding div from the DOM tree
 */
export function removeBottomSheet(ref?: React.RefObject<any>): void {
    const id = ref?.current?.props?.id;
    const bottomSheetDiv = getBottomSheetAnimatedDiv(id);
    if (bottomSheetDiv) {
        ReactDOM.unmountComponentAtNode(bottomSheetDiv);
        purgeBottomSheetAnimatedDiv(id);
    }
}

export default removeBottomSheet;
